import MicroModal from 'micromodal'; // es6 module

function getModalLinks() {
  return document.querySelectorAll('a[href*="/modal/"]');
}

function makeLinksOpenModal(links) {
  for (let i = 0; i < links.length; i++) {
    const link = links[i];
    const linkParent = link.parentNode;

    // Get slug from href
    const href = link.href;
    const slugRegex = /\/modal\/([^/]*)/g;
    const slugWithSection = href.match(slugRegex)[0];
    const slug = slugWithSection.replace('/modal/', '');

    // Get link attributes
    const linkAttributes = link.attributes;

    // Init new button
    const newButton = document.createElement('button');

    // Add each attribute to the new button
    for (let j = 0; j < linkAttributes.length; j++) {
      const attribute = linkAttributes[j];
      if (attribute.nodeName !== 'href') {
        newButton.setAttribute(attribute.nodeName, attribute.value);
      }
    }

    // Add innerHTML from link to new button
    newButton.innerHTML = link.innerHTML;

    // add micromodal attribute
    newButton.setAttribute('data-micromodal-trigger', 'modal-' + slug);

    // Add button to doc
    linkParent.insertBefore(newButton, link);

    // Remove link element
    link.remove();
  }
}

function setupModalLinks() {
  const modalLinks = getModalLinks();

  makeLinksOpenModal(modalLinks);
}

function modalShown() {
  document.querySelector('body').classList.add('overlay-menu-open');
}

function modalClosed() {
  document.querySelector('body').classList.remove('overlay-menu-open');
}

document.addEventListener('DOMContentLoaded', function () {
  setupModalLinks();

  // Init micromodal after setting up the modal links, so it binds stuff to them
  MicroModal.init({
    onShow: modalShown,
    onClose: modalClosed,
  });
});
